import { PdMoreInfo } from "./pd-more-info/PdMoreInfo.js";
//#region src/pd-more-info/pd-more-info.ts
var tag = "pd-more-info";
if (!customElements.get(tag)) customElements.define(tag, PdMoreInfo);
//#endregion
export { PdMoreInfo };
